const formatDate = (date) => {
  date = moment.utc(date).local()
  return date.format('Do MMMM YYYY, h:mm A');
}

export default formatDate;




// WEBPACK FOOTER //
// ./src/helpers/FormatDate/index.js